import { LocationProfile } from 'src/app/core/models/admin';

export const CONSTS = {
  ACTIVATED: $localize`Activated`,
  DEACTIVATED: $localize`Deactivated`,
};

export interface Option {
  label: string;
  value: string;
}

export interface LocationPropertiesTypes {
  locationCode: string;
  locationName: string;
  pkgSlic: string;
  hubSlic: string;
  mnemonic: string;
  region: string;
  district: string;
  ospId: string;
  locationSetup: string;
  gmtTimeZone: string;
  apiKey: string;
}

export type LocationFormCopy = LocationPropertiesTypes | LocationProfile;
